import React, { useEffect, useState, useContext, useCallback } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { ApiBaseUrlContext } from '../App';
import moment from 'moment';
import { useNavigate } from 'react-router-dom'; // 1️⃣ Import useNavigate
import { ReactComponent as LinkArrowIcon } from '../assets/svg/icon-small-arrow.svg';
import { formatDateByLocale } from '../utils/dateUtils';


const Section2 = () => {
  const apiBaseUrl = useContext(ApiBaseUrlContext);
  const [maintenanceList, setMaintenanceList] = useState({
    overdue: [],
    today: [],
  });
  const [machines, setMachines] = useState([]); // To map machine IDs to machine names.
  const [isMachinesLoaded, setIsMachinesLoaded] = useState(false); // Track if machines have been loaded
  const { t, i18n } = useTranslation();
    const navigate = useNavigate(); // 2️⃣ Initialize the hook

  const fetchMachines = useCallback(async () => {
    if (isMachinesLoaded) return; // Avoid repeated fetches if machines are already loaded
    try {
      const response = await axios.get(`${apiBaseUrl}/mnt/api/machines/all`);
      console.log('Machines Data:', response.data);
      setMachines(response.data);
      setIsMachinesLoaded(true); // Mark machines as loaded
    } catch (error) {
      console.error('Error fetching machines:', error);
    }
  }, [apiBaseUrl, isMachinesLoaded]);

  const fetchMaintenanceList = useCallback(async () => {
    try {
      const params = {
        status: [],
      };
      const response = await axios.get(`${apiBaseUrl}/mnt/api/maintenance`, { params });
      console.log('Maintenance Schedule Data:', response.data);
  
      const currentDate = moment().startOf('day');
      const validMaintenance = Array.isArray(response.data)
        ? response.data.filter(item => {
            // Skip items with status Closed or without a matching machine.
            if (item.status === 'Closed') return false;
            return machines.some(m => m.machineid === item.machineid);
          })
        : [];
  
      const categorizedMaintenance = validMaintenance.reduce((acc, item) => {
        const maintenanceDate = moment.unix(item.next_maintenance_date).startOf('day');
        if (maintenanceDate.isBefore(currentDate)) {
          acc.overdue.push(item);
        } else if (maintenanceDate.isSame(currentDate, 'day')) {
          acc.today.push(item);
        }
        return acc;
      }, { overdue: [], today: [] });
  
      console.log('Categorized Maintenance:', categorizedMaintenance);
      setMaintenanceList(categorizedMaintenance);
    } catch (error) {
      console.error('Error fetching maintenance schedule:', error);
    }
  }, [apiBaseUrl, machines]);
  

  useEffect(() => {
    fetchMachines();
  }, [fetchMachines]); // Fetch machines only once

  useEffect(() => {
    if (isMachinesLoaded) {
      fetchMaintenanceList(); // Fetch maintenance list only after machines are loaded
    }
  }, [fetchMaintenanceList, isMachinesLoaded]); // Correct dependencies

  const formatItem = (item, color, status) => {
    const machineName = machines.find(m => m.machineid === item.machineid)?.machine || t('Section2.UnknownMachine');
    const repeatInfo = item.repeat_enabled
      ? item.maintenance_type === 'custom'
        ? t('Section2.RepeatsEvery', { days: item.repeat_interval / 86400 })
        : ` (${item.maintenance_type.charAt(0).toUpperCase() + item.maintenance_type.slice(1)})`
      : '';
      return (

        // ${item.maintenance_type} ${t('Section2.Scheduled')}: 

        <div className={`db-box__entry-container db-box__entry-container-${color}`}>

          <div className="db-box__entry-row-top">
            <div className={`db-box__label db-box__label-${color}`}>{`${status}`}</div>
            <div className="db-box__entry-date">{`${formatDateByLocale(item.next_maintenance_date, i18n.language, false)} ${repeatInfo}`}</div>
          </div>

          <div className="db-box__entry-eqipment-name">{`${machineName}`}</div>
        </div>
  
      );
  };

  const renderSection = (title, items, color, maxItems, noDataMessage, moreMessage, status) => (
    
    <div>
      <div className="db-box__section-header">{title}</div>
      {items.length > 0 ? (
        <>
          {items.slice(0, maxItems).map((item, index) => (
            <div key={index}>{formatItem(item, color, status)}</div>
          ))}
          {items.length > maxItems /* && <p>{moreMessage}</p> */ }
        </>
      ) : (
        <div className="db-box__section-text">{noDataMessage}</div>
      )}
    </div>

  );
  const handleButtonClick = () => {
    navigate('/maintenance-schedule');
  };
  return (
    <div class="db-box db-box_order-2">

      <div class="db-box__title-row">				
        
              <button
                  type="button"
                  className="db-box__title-btn"
                  aria-label="Scheduled Maintenance"
                  id="errors"
                  onClick={handleButtonClick}
                >
                  {t('Section2.ScheduledMaintenance')} 
                  <LinkArrowIcon />
                </button>
                <div className="db-box__title-stat">
    {maintenanceList.overdue.length} {t('Section2.Overdue')}
  </div>


  <div className="db-box__title-stat">
    {maintenanceList.today.length} {t('Section2.Today')}
  </div>
      </div>

      <div className='dashboard-section-content'>

        {renderSection(
          t('Section2.OverdueMaintenance'),
          maintenanceList.overdue,
          'red',
          5,
          t('Section2.NoOverdueMaintenance'),
          t('Section2.MoreOverdueMaintenance'),
          t('Section2.Overdue')
        )}

        {renderSection(
          t("Section2.TodayMaintenance"),
          maintenanceList.today,
          'blue',
          5,
          t("Section2.NoTodayMaintenance"),
          t("Section2.MoreTodayMaintenance"),
          t("Section2.Today")
        )}
   
      </div>
    </div>
  );
};

export default Section2;
